/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { SDK_FRAGMENT_NAME, msdyn365Commerce } from '@msdyn365-commerce/core-internal';
import * as path from 'path';
import * as React from 'react';
import { isAbsoluteUrl } from '@msdyn365-commerce/core';
import { IExtExternalScriptProps } from './ext-external-script.props.autogenerated';

/**
 *
 * DefaultExternalScript component
 * @extends {React.PureComponent<IDefaultExternalScriptProps<{}>>}
 */
class DefaultExternalScript extends React.PureComponent<IExtExternalScriptProps<{}>> {
    constructor(props: IExtExternalScriptProps<{}>) {
        super(props);
    }
    public render(): JSX.Element | null {
        const { config } = this.props;
        this.props.telemetry.debug(`Adding script tags for '${this.props.id}/${this.props.typeName}'`, this.props.telemetry);
        let source = config.scriptSource;
        let relativeBaseUrl: string = '';
        // Construct the relative base url, i.e. the base url from which statics will be served
        if (this.props.context) {
            relativeBaseUrl += this.props.context.request.url.staticCdnUrl;
            relativeBaseUrl += msdyn365Commerce.getEnvironmentVariable('SUBMISSIONID') || '';
        }
        if (isRelativeUrl(source)) {
            // If the source is a relative URL prepend the relative base url to the resolved source url for the actual source
            source = `${relativeBaseUrl}/${path.join(source)}`;
        } else if (source === '' || !isAbsoluteUrl(source)) {
            this.props.telemetry.error(
                'Invalid external script - not a url. The external source is not an external or relative url, please use default-inline-script if you wish to load inline scripts',
                this.props.telemetry
            );
            return null;
        }
        let scriptAttr = '';
        config.scriptAttributes?.forEach(attr => {
            scriptAttr += `${attr.attributeKey}='${attr.attributeValue}' `;
        });
        const scriptHtml = `<script src="${source}" async=${!!config.async} defer=${!!config.defer} ${scriptAttr}></script>`;
        return React.createElement(SDK_FRAGMENT_NAME, { key: this.props.id, dangerouslySetInnerHTML: { __html: scriptHtml } });
    }
}
export default DefaultExternalScript;

const isRelativeUrl = (source: string): boolean => {
    return /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/).*(\.js){1}$/.test(source);
};
